import React, { FC, useContext } from 'react'
import { BookingFolder } from '../../common/types/booking'

import GlobalContext from '../../contexts/GlobalContext'
//import { useRouter } from '../../hooks/useRouter'
import {  useParams } from 'react-router-dom';

type Props = {
  bookingFolder: BookingFolder
  completionRates: any
}

const HeaderPreCheckin: FC<Props> = ({
  bookingFolder, completionRates
}) => {
  const [globalContext] = useContext(GlobalContext) as any
  //const router = useRouter()
  let { id } = useParams();

  const globalCompletionRate = completionRates?.global?.folderList?.[id]?.rate ?? 0

  return (
    <div style={{padding: "9px 5px 9px 25px"}}>
      {globalContext.translations.titlePreCheckInPartOne} n°<strong className="mbBlue"> 
      &nbsp;{bookingFolder?.number}</strong>. 
      &nbsp;{globalContext.translations.titlePreCheckInPartTwo} 
      &nbsp;<strong style={{color: "#2185d0"}}>{bookingFolder?.roomTotal}</strong> 
      &nbsp;{globalContext.translations.titlePreCheckInPartThree} 
      &nbsp;<strong style={{color: "#2185d0"}}>{bookingFolder?.paxTotal}</strong> 
      &nbsp;{globalContext.translations.titlePreCheckInPartFour}.<br /> 
      {globalContext.translations.titlePreCheckInPartFive} 
      &nbsp;<strong style={{color: "#2185d0"}}>{globalCompletionRate}%</strong>
    </div>
  )
}

export default HeaderPreCheckin